import { defineComponent as _defineComponent } from 'vue'
import {Component} from "vue";

type step = {
  id: string
  title: string;
  icon: string;
  isCompleted: boolean;
  component: Component
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBarSteps',
  props: {
    steps: null,
    value: null,
    maxWidthContainer: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value: step): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  steps: step[];
  value: step;
  maxWidthContainer?: number;
};






function onStepClick(clickedStep: step, index: number) {
  const isCompletedPreviousStep = props.steps[index - 1] && props.steps[index - 1].isCompleted;
  const isFirst = index === 0;
  const isActiveStep = props.value.id === clickedStep.id;

  if ((!isCompletedPreviousStep && !isFirst) || isActiveStep) {
    return;
  }

  emit('input', clickedStep)
}

return { __sfc: true,props, emit, onStepClick }
}

})